import React from 'react';
import {View} from 'MWC';
import tpl from './templates/interactive.jsx';
import Model from './models/requestParams.m';
import PropTypes from 'prop-types';
import buildUrl from 'utils/buildGetURLWithParams';
import {apiback} from '../../config';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            model: new Model(),
            departments: [],
            workTypes: [],
            cities: []
        };
        this.getDepartments();
        this.getWorkTypes();
        this.getCities();
        return this;
    }

    getDepartments = () => {
        const url = buildUrl(apiback('API_DEPARTMENTS'), {});
        fetch(url)
            .then(res => res.json())
            .then(({data}) => {
                this.setState({
                    departments: data,
                    departmentsUA: this.getFilteredArr(data, 'name_ua'),
                    departmentsRU: this.getFilteredArr(data, 'name_ru')
                });
            });
        // .catch(x => console.log('error:', x)); //todo добавить обработчик
    };

    getWorkTypes = () => {
        const url = buildUrl(apiback('API_WORK_TYPES'), {});
        fetch(url)
            .then(res => res.json())
            .then(({data}) => {
                this.setState({
                    workTypes: data,
                    workTypesUA: this.getFilteredArr(data, 'name_ua'),
                    workTypesRU: this.getFilteredArr(data, 'name_ru')
                });
            });
        // .catch(x => console.log('error:', x)); //todo добавить обработчик
    };

    getCities = () => {
        const url = buildUrl(apiback('API_CITIES'), {});
        fetch(url)
            .then(res => res.json())
            .then(({data, total}) => {
                this.setState({
                    cities: data,
                    citiesUA: this.getFilteredArr(data, 'name_ua'),
                    citiesRU: this.getFilteredArr(data, 'name_ru')
                });
            });
        // .catch(x => console.log('error:', x)); //todo добавить обработчик
    };

    getFilteredArr(arr, param) {
        return arr.map(item => {
            return {id: item.id, name: item[param]};
        });
    }

    static displayName = 'Career';
    static contextTypes = {
        app: PropTypes.object
    };
}
